import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { SocketProvider } from './contexts/SocketContext'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/auth/LoginPage'
import SignUpPage from './pages/auth/SignUpPage'
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage'
import ResetPasswordPage from './pages/auth/ResetPasswordPage'
import VerifyEmailPage from './pages/auth/VerifyEmailPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfUsePage from './pages/TermsOfUsePage'
import OverlayLanding from './pages/overlay/OverlayLanding'
import OverlayEditor from './pages/overlay/OverlayEditor'
import OverlayControl from './pages/overlay/OverlayControl'
import PopupEditor from './pages/overlay/PopupEditor'
import MemberScrollEditor from './pages/overlay/MemberScrollEditor'
import ChatLanding from './pages/chat/ChatLanding'
import ChatEditor from './pages/chat/ChatEditor'
import ChatControl from './pages/chat/ChatControl'
import ChatHost from './pages/chat/ChatHost'
import BroadcastOutput from './pages/broadcast/BroadcastOutput'
import LoadingSpinner from './components/LoadingSpinner'
import PageWrapper from './components/PageWrapper'

function App() {
  const { user, loading } = useAuth()
  const location = useLocation()
  
  // Detect if current route is a broadcast route (needs transparency for OBS)
  const isBroadcastRoute = location.pathname.startsWith('/broadcast/') || 
                           location.pathname.match(/^\/overlays\/[^\/]+\/view$/)

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <SocketProvider>
      <div 
        className={`min-h-screen ${isBroadcastRoute ? '' : 'bg-gray-900'}`}
        style={isBroadcastRoute ? { background: 'transparent' } : {}}
      >
        <Routes>
        {/* Public Routes */}
        <Route 
          path="/login" 
          element={user ? <Navigate to="/" replace /> : <LoginPage />} 
        />
        <Route 
          path="/signup" 
          element={user ? <Navigate to="/" replace /> : <SignUpPage />} 
        />
        <Route 
          path="/forgot-password" 
          element={user ? <Navigate to="/" replace /> : <ForgotPasswordPage />} 
        />
        <Route 
          path="/reset-password" 
          element={user ? <Navigate to="/" replace /> : <ResetPasswordPage />} 
        />
        <Route 
          path="/verify-email" 
          element={user ? <Navigate to="/" replace /> : <VerifyEmailPage />} 
        />
        <Route 
          path="/privacy-policy" 
          element={<PrivacyPolicyPage />} 
        />
        <Route 
          path="/terms-of-use" 
          element={<TermsOfUsePage />} 
        />
        
        {/* Broadcast Output (Public) */}
        <Route 
          path="/broadcast/overlay/:id" 
          element={<BroadcastOutput />} 
        />
        <Route 
          path="/broadcast/chat/:id" 
          element={<BroadcastOutput />} 
        />
        <Route 
          path="/overlays/:id/view" 
          element={<BroadcastOutput />} 
        />
        
        {/* Protected Routes */}
        <Route 
          path="/" 
          element={user ? <PageWrapper title="LANDING PAGE"><LandingPage /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/overlay" 
          element={user ? <PageWrapper title="OVERLAY LANDING"><OverlayLanding /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/overlays/new" 
          element={user ? <PageWrapper title="OVERLAY EDITOR"><OverlayEditor /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/overlays/:id/edit" 
          element={user ? <PageWrapper title="OVERLAY EDITOR"><OverlayEditor /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/overlays/:id/control" 
          element={user ? <PageWrapper title="OVERLAY CONTROL"><OverlayControl /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/popups" 
          element={user ? <PageWrapper title="POPUP EDITOR"><PopupEditor /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/member-scroll" 
          element={user ? <PageWrapper title="MEMBER SCROLL EDITOR"><MemberScrollEditor /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chat" 
          element={user ? <PageWrapper title="CHAT LANDING"><ChatLanding /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chat/new" 
          element={user ? <PageWrapper title="CREATE CHAT CONFIG"><ChatEditor /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chat/:id/edit" 
          element={user ? <PageWrapper title="CHAT EDITOR"><ChatEditor /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chat/:id/control" 
          element={user ? <PageWrapper title="CHAT CONTROL"><ChatControl /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        <Route 
          path="/chat/:id/host" 
          element={user ? <PageWrapper title="CHAT HOST"><ChatHost /></PageWrapper> : <Navigate to="/login" replace />} 
        />
        
        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </SocketProvider>
  )
}

export default App
